<template>
	<div id="app">
		<HelloWorld msg="Welcome to Your Vue.js App" v-if="listenshow" />
		<Start msg='login' v-else />

	</div>
</template>

<script>

import HelloWorld from './components/HelloWorld.vue'
// import HelloWorld from './components/HelloWorld0.vue'
	import Start from './components/Start_call.vue'

	export default {
		name: 'App',
		components: {
			HelloWorld,
			Start
		},
		data() {
			return {
				show: false,
			}
		},
		computed: {
			listenshow() {
				return this.$store.state.login;
			}
		}
	}
</script>

<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin: -8px -8px -8px -8px;
		background-color:#000;
		height: 100vh;;
	}
</style>
